/* eslint-disable */
import $ from "jquery";
import anchorJS from "anchor-js";

class Anchors {
  constructor(el) {
    const anchors = new anchorJS(); // eslint-disable-line
    anchors.options = {
      placement: "left"
    };
    anchors.add(el);
    if (anchors.elements.length > 2) {
      this.generateTableOfContents(anchors.elements);
    }
  }

  // External code for generating a simple dynamic Table of Contents.
  generateTableOfContents(els) {
    let anchoredElContent = null;
    let anchoredElHref = "";
    const ul = document.createElement("UL");

    document.getElementById("jumplinks").appendChild(ul);

    for (let i = 0; i < els.length; i += 1) {
      anchoredElContent = this.getAnchorContent(els[i]);
      anchoredElHref = els[i]
        .querySelector(".anchorjs-link")
        .getAttribute("href");
      els[i].querySelector(".anchorjs-link").setAttribute("aria-hidden", "true");
      this.addNavItem(ul, anchoredElHref, anchoredElContent);
    }
  }

  getAnchorContent(el) {
    // Clone heading content so inline semantics (e.g. <span lang="mi">) are preserved.
    const clone = el.cloneNode(true);

    // Remove anchorjs-injected links from copied content.
    Array.from(clone.querySelectorAll(".anchorjs-link")).forEach(link => {
      link.remove();
    });

    const fragment = document.createDocumentFragment();

    Array.from(clone.childNodes).forEach(node => {
      fragment.appendChild(node);
    });

    return fragment;
  }

  addNavItem(ul, href, content) {
    const listItem = document.createElement("LI");
    const anchorItem = document.createElement("A");

    anchorItem.href = href;
    ul.appendChild(listItem);
    listItem.appendChild(anchorItem);
    anchorItem.appendChild(content);
    anchorItem.setAttribute("aria-hidden", "false");

    this.bindClickHandler(anchorItem, href);
  }

  bindClickHandler(el, href) {
    $(el).click(e => {
      e.preventDefault();
      let anchor = $(`a.anchorjs-link[href*="${href}"]`);
      // scroll to top
      const top = anchor.offset().top;
      $("html, body").animate({ scrollTop: top }, 500);
      // set focus at our anchor for accessibility
      anchor.focus();
      anchor.attr('aria-hidden', 'false')
    });
  }
}

export default Anchors;
/* eslint-enable */
